// extracted by mini-css-extract-plugin
export default {"app":"FxYK9LtmPWdCNZAsfgtQ","header":"zoNAgHcXnS4U8x2vOr2Y","content":"_2lIdjZk4YreL2Ibjefu"};